import React from "react";
import {
  CountrySelect,
  StateSelect,
  CitySelect,
} from "react-country-state-city";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import FormError from "../formError/FormError";

const ClientFormAddress = ({
  client,
  onChange,
  allow,
  translate,
  form,
  onChangeCheckbox,
  readOnly,
}) => {
  if (!IsAllow(allow, "customer-01")) return null;

  return (
    <>
      <div>
        <div className="flex items-center gap-4 mb-2">
          <label className="label">{translate("street-address")}</label>
          <div
            className={`flex items-center px-2 py-1 rounded ${
              client.verificationAddress
                ? "bg-blue-500"
                : "bg-slate-900 dark:bg-slate-300"
            }`}
          >
            <input
              name="verificationAddress"
              type="checkbox"
              className="mr-2"
              onChange={onChangeCheckbox}
              checked={!!client.verificationAddress}
              disabled={readOnly}
            />
            <span
              className={`text-xs ${
                client.verificationAddress
                  ? "text-white"
                  : "text-white dark:text-gray-900 "
              }`}
            >
              {translate("verify-address")}
            </span>
          </div>
        </div>
        <input
          type="text"
          name="streetAddress"
          value={client.streetAddress}
          onChange={onChangeCheckbox}
          className="input"
          disabled={readOnly}
        />
        <FormError form={form} name="streetAddress" />
      </div>
      <div>
        <label className="label">{translate("zip-code")}</label>
        <input
          type="text"
          name="zipCode"
          value={client.zipCode}
          onChange={onChangeCheckbox}
          className="input"
          disabled={readOnly}
        />
        <FormError form={form} name="zipCode" />
      </div>
      <div>
        <label className="label">{translate("country")}</label>

        <CountrySelect
          name="country"
          defaultValue={client.country}
          containerClassName="dark:bg-gray-700 dark:fill-white"
          inputClassName="bg-gray-50 border-none text-gray-900 text-sm rounded-lg focus:ring-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500"
          onChange={(val) => onChange("country", val)}
          placeHolder={translate("country-select")}
          disabled={readOnly}
        />
        <FormError form={form} name="country" />
      </div>
      <div>
        <label className="label">{translate("state")}</label>
        <StateSelect
          countryid={client.country?.id}
          defaultValue={client.state}
          containerClassName="dark:bg-gray-700 dark:fill-white"
          inputClassName="bg-gray-50 border-none text-gray-900 text-sm rounded-lg focus:ring-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500"
          onChange={(val) => onChange("state", val)}
          placeHolder={translate("state-select")}
          disabled={readOnly}
        />
        <FormError form={form} name="state" />
      </div>
      <div>
        <label className="label">{translate("city")}</label>
        <CitySelect
          countryid={client.country?.id}
          stateid={client.state?.id}
          defaultValue={client.city}
          containerClassName="dark:bg-gray-700 dark:fill-white"
          inputClassName="bg-gray-50 border-none text-gray-900 text-sm rounded-lg focus:ring-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500"
          onChange={(val) => onChange("city", val)}
          placeHolder={translate("city-select")}
          disabled={readOnly}
        />
        <FormError form={form} name="city" />
      </div>
    </>
  );
};

export default ClientFormAddress;
